import React from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'
import throttle from 'lodash/throttle'

import { transmit, gtmPush } from 'actions/naughtyActions'
import { shouldTrack } from 'selectors/authSelectors'
import { getGTMPayload } from 'selectors/naughtySelectors'

/*
 * GTMPush
 *
 * This component's purpose is to watch for changes in quote payments and push
 * the result into the window.dataLayer array for use with GTM, et al.
 *
 * It also sets up a manual transmit call and a beforeunload event to transmit
 * any left over events that haven't been sent yet. TODO the utility of this
 * function is questionable now that the events sent via websocket.
 *
 */

export class GTMPush extends React.Component {
  constructor(...args) {
    super(...args)

    this.gtmPush = throttle(() => this.props.gtmPush(this.props.gtmPayload), 1)
  }

  componentDidUpdate(prevProps) {
    let { gtmPayload } = this.props

    if (
      !isEmpty(gtmPayload) &&
      get(gtmPayload, 'VIN') &&
      !isEqual(prevProps.gtmPayload, gtmPayload)
    )
      this.gtmPush()
  }

  componentDidMount() {
    let { transmit, shouldTrack } = this.props

    if (!shouldTrack) return

    transmit()
    window.addEventListener('beforeunload', transmit)
  }

  render() {
    return null
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    shouldTrack: shouldTrack(state),
    gtmPayload: getGTMPayload(state),
  }
}

export default connect(
  mapStateToProps,
  { transmit, gtmPush },
)(GTMPush)
